import 'isomorphic-fetch'
import {configureFormInputs, reindexTicketInputs} from "./Event";
const ENTER = 13;
export function setupLockedTickets(onTicketsAdded) {
  const $lockedTickets = $('.locked-template');
  if (!$lockedTickets.length) return;
  
  const instances = [];
  $lockedTickets.each((_, el) => {
    const instance = createLockedTicket($(el), onTicketsAdded);
    instances.push(instance);
  });
  
  return {
    count: () => instances.length
  };
}

function createLockedTicket($el, onTicketsAdded) {
  const $input = $el.find('input.template-code');
  const $button = $el.find('.unlock-btn');
  
  const templateId = $el.data('template');
  const catalogId = $el.data('event-id');
  const isSeason = $el.data('is-season');
  
  $input.keyup(e => {
    if (e.keyCode === ENTER) {
      $button.click();
    }
  });
  
  $button.click(async () => {
    const accessCode = $input.val()?.trim();
    if (!accessCode) return;
    
    try {
      const result = await tryUnlock(catalogId, isSeason, templateId, accessCode, $el);
      
      const $newEl = $(result.target)
      
      if (result.ok) {
       
          const templateId = $newEl.data('template');
          if (templateId) {
              const headerId = 'heading-' + templateId;
              // Remove existing header before inserting new one
              $('h3.accordion-header#' + headerId).remove();
          }
          onTicketsAdded($newEl[0]);
      }
      else {
        createLockedTicket($newEl, onTicketsAdded);
      }
    }
    catch (err) {
      console.error('Unlock failed:', err);
    }
  })
  return { el: $el }
}

async function tryUnlock(catalogId, isSeason, templateId, accessCode, $container) {
  const formData = new URLSearchParams({
    catalogId,
    isSeason,
    templateId,
    accessCode
  })

  $container.hide()

  const response = await fetch('/Tickets/UseAccessCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData,
    credentials: 'same-origin'
  })


  const html = await response.text()
  const $rendered = $(html)
  
  $container.replaceWith($rendered);
  reindexTicketInputs();
  configureFormInputs($rendered);

  return {
    ok: response.ok,
    target: $rendered
  }
}